module.exports = __webpack_public_path__ + "static/media/back_to_btn_20.15843501.svg";